<template>
  <div class="sdg-item">
    <sdg-icon class="sdg-icon" :sdg="sdg" />
    <span class="sdg-title">{{ sdgTitle }}</span>
  </div>
</template>

<script>
import sdgIcon from '@/components/sdg-icon'
import options from '@/data/options'

export default {
  name: 'sdg-item',
  components: {
    sdgIcon,
  },
  props: {
    sdg: {
      type: String,
      required: true,
    },
  },
  computed: {
    sdgTitle() {
      const option = options.sdgOptions.find(item => item.code === this.sdg)
      return option ? option.text : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.sdg-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.sdg-icon {
  width: 40px;
  height: 40px;
  margin-right: 14px;
}
.sdg-title {
  max-width: 170px;
}
</style>
